import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <section className="py-24 px-6 relative overflow-hidden" data-id="element-84">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-10" data-id="element-85">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute w-full h-full" data-id="element-86">
          <path d="M0,50 Q25,20 50,50 T100,50 L100,100 L0,100 Z" fill="#2D5016" data-id="element-87" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-88">
        <motion.div className="bg-brand-green text-brand-cream p-8 md:p-12 rounded-3xl shadow-2xl relative" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-89">
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-brand-gold rounded-full opacity-20 blur-2xl" data-id="element-90"></div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-gold" data-id="element-91">
            La solución no es comer menos, es activar tu "Pausa Metabólica".
          </h2>

          <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-92">
            Este es un Protocolo de Desinflamación de 24 Horas que envía una
            señal química a tus células para que dejen de retener líquidos y
            comiencen a procesar energía.
          </p>

          <p className="text-lg md:text-xl leading-relaxed font-light" data-id="element-93">
            No es una dieta; es un reinicio de tus sensores de insulina y una
            limpieza de tu sistema digestivo mediante el descanso estratégico y
            nutrientes específicos que apagan el "incendio" de la inflamación
            sistémica.
          </p>
        </motion.div>
      </div>
    </section>;
}